export const PRODUCT_CLIENT_ACTION = {
    GET_PRODUCT_LIST: "PRODUCT_CLIENT_ACTION/GET_PRODUCT_LIST",
    GET_PRODUCT_LIST_BY_CATEGORY: "PRODUCT_CLIENT_ACTION/GET_PRODUCT_LIST_BY_CATEGORY",
    CLEAR_PRODUCT_LIST: "PRODUCT_CLIENT_ACTION/CLEAR_PRODUCT_LIST",
    CREATE_PRODUCT: "PRODUCT_CLIENT_ACTION/CREATE_PRODUCT",
    GET_PRODUCT_DETAIL: "PRODUCT_CLIENT_ACTION/GET_PRODUCT_DETAIL",
    UPDATE_PRODUCT_DETAIL: "PRODUCT_CLIENT_ACTION/UPDATE_PRODUCT_DETAIL",
    GET_SEARCH_LIST: "PRODUCT_CLIENT_ACTION/GET_SEARCH_LIST",
    CLEAR_PRODUCT_DETAIL: "PRODUCT_CLIENT_ACTION/CLEAR_PRODUCT_DETAIL",
};
